var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "600",
      "persistent": ""
    },
    on: {
      "input": _vm.closeModal
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Добавить') + " ")]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0 pt-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '########',
      expression: "'########'"
    }],
    attrs: {
      "label": "Номер приказа",
      "placeholder": "Введите номер приказа",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.errorMessages.orderNumber
    },
    on: {
      "input": function input($event) {
        return _vm.$v.order.orderNumber.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.order.orderNumber.$touch();
      }
    },
    model: {
      value: _vm.order.orderNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "orderNumber", $$v);
      },
      expression: "order.orderNumber"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('UIDatePicker', {
    attrs: {
      "label": "Дата приказа",
      "error-messages": _vm.errorMessages.orderDate
    },
    on: {
      "input": function input($event) {
        return _vm.$v.order.orderDate.$touch();
      }
    },
    model: {
      value: _vm.order.orderDate,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "orderDate", $$v);
      },
      expression: "order.orderDate"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('UIDatePicker', {
    attrs: {
      "label": "Дата начала действия приказа",
      "error-messages": _vm.errorMessages.effectiveDate
    },
    on: {
      "input": function input($event) {
        return _vm.$v.order.effectiveDate.$touch();
      }
    },
    model: {
      value: _vm.order.effectiveDate,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "effectiveDate", $$v);
      },
      expression: "order.effectiveDate"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.paidForm,
      "item-text": "name",
      "label": "Вид оплаты",
      "placeholder": "Выберите из списка",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.paidForm
    },
    on: {
      "input": function input($event) {
        return _vm.$v.order.paidForm.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.order.paidForm.$touch();
      }
    },
    model: {
      value: _vm.order.paidForm,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "paidForm", $$v);
      },
      expression: "order.paidForm"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.speciality,
      "item-text": "name",
      "label": "Специальность",
      "placeholder": "Выберите из списка",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.speciality
    },
    on: {
      "input": function input($event) {
        return _vm.$v.order.speciality.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.order.speciality.$touch();
      }
    },
    model: {
      value: _vm.order.speciality,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "speciality", $$v);
      },
      expression: "order.speciality"
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s('Отмена') + " ")]), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.$v.$invalid,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveOrder
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Сохранить' : 'Создать') + " ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }